import {CURRENT_LOCATION, SHOW_SELECTED, LAT_LONG} from "../action/actionConstants";

export default function location(state = {showSelected : true,
                                          location : "Click to select location",
                                          locationLatLon : [24.3865729, 54.2784165]}, action) {
  switch (action.type) {

    case CURRENT_LOCATION: {
      return {...state,
       location: action.payload
     }
   }
     case SHOW_SELECTED : {
       return {...state,
        showSelected: action.payload
      }
    }
    case LAT_LONG : {
      return {...state,
       locationLatLon: action.payload
     }
   }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/location.js